export const code = text => {
  return `{{${text}}}`;
};